import React, { useEffect, useState } from "react";
import "./LandingPage.css";
import Header from "../../../common/components/Header/Header";
import Button from "../../../common/components/Button/Button";
import { useNavigate } from "react-router-dom";
import UIConfig from "../../../common/constants/UIConfig";
import { toast } from "react-toastify";

import Dashboard from "../../../assets/images/Dashboard.png";
import new_agent_home from "../../../assets/images/new_agent_home.png";
import support_agent_working from "../../../assets/images/support_agent_working.png";
import { useDispatch, useSelector } from "react-redux";
import {
  setActiveSearch,
  setSearchFields,
} from "../../../redux/slices/operationHomeSlice";
// import LoginUser from "../../../common/components/HeaderOpsPage/Header";
import Navbar from "../../../common/components/HeaderOpsPage/Navbar";

const LandingPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isOperationsHomeEnabled] = useState(true);

  const { data } = useSelector((state) => state.login.login);

  const userRole = data?.data[0]?.Role || "Unknown";
  const userEmail = (data?.data?.[0]?.Email || "").toLowerCase();
  const ALLOWED_OPS_DOMAINS = ["@montenido.com", "@magichealth.io"];
  const isAuthorizedOpsManager =
    userRole === "Operations Manager" &&
    ALLOWED_OPS_DOMAINS.some((d) => userEmail.endsWith(d));

  console.log("Role ==", userRole);

  const goToOperationHome = () => {
    toast.dismiss();
    if (isOperationsHomeEnabled) navigate("/operationhome");
  };
  const goToAgentHome = () => {
    toast.dismiss();
    navigate("/agenthome");
  };

  useEffect(() => {
    dispatch(setActiveSearch(""));
    dispatch(setSearchFields(null));
  }, [dispatch]);

  return (
    <>
      <Navbar />
      <div className="navigation-page d-flex justify-content-center align-items-center">
        <div className="landing_border-container">
          <div className="image-container">
            <img
              src={UIConfig.landing.backgroundImage}
              alt="Contact Center"
              className="img-fluid landingPage-image"
            />
          </div>

          <div className="card welcome-card">
            <div className="card-body">
              <h2 className="card-title">{UIConfig.landing.title}</h2>
              <h5 className="card-subtitle start-0 text-dark fs-6 lh-base">
                {UIConfig.landing.subTitle}
              </h5>
              <p className="card-text1">{UIConfig.landing.text}</p>
              <p className="card-text2">{UIConfig.landing.footer}</p>

              <div className="button-container">
                <Button
                  className="grid-btn"
                  onClick={goToOperationHome}
                  disabled={!isOperationsHomeEnabled}
                >
                  <img src={support_agent_working} alt="icon" />
                  <span>{UIConfig.landing.operationHomeBtnText}</span>
                </Button>

                <Button
                  className="grid-btn"
                  onClick={() => navigate("/agenthome ")}
                >
                  <img src={new_agent_home} alt="icon" />
                  <span>{UIConfig.landing.agentBtnText}</span>
                </Button>

                {userRole !== "Agent" && (
                  <>
                    <Button
                      className="grid-btn"
                      onClick={() => {
                        // The MH Insights dashboard sends X-Frame-Options: DENY,
                        // so it can't be iframed. Open it in a new tab instead.
                        // Fall back to the in-app /dashboardPage if the env var
                        // is missing (which renders a friendly "Open Dashboard"
                        // page rather than a broken iframe).
                        const url = process.env.REACT_APP_INSIGHTS_DASHBOARD_URL;
                        if (url) {
                          window.open(url, "_blank", "noopener,noreferrer");
                        } else {
                          navigate("/dashboardPage");
                        }
                      }}
                    >
                      <img src={Dashboard} alt="icon" />
                      <span>{UIConfig.landing.dashboardBtnText}</span>
                    </Button>

                    <Button
                      className="grid-btn"
                      onClick={() => navigate("/performancedashboardPage")}
                    >
                      <img src={Dashboard} alt="icon" />
                      <span>{UIConfig.landing.performanceBtnText}</span>
                    </Button>

                    {userRole === "Admin" && (
                      <Button
                        className="grid-btn"
                        onClick={() => navigate("/analytics")}
                      >
                        <img src={Dashboard} alt="icon" />
                        <span>API Analytics</span>
                      </Button>
                    )}

                    {(userRole === "Admin" || isAuthorizedOpsManager) && (
                      <Button
                        className="grid-btn"
                        onClick={() => navigate("/montenido-usage")}
                      >
                        <img src={Dashboard} alt="icon" />
                        <span>Montenido Usage</span>
                      </Button>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>

          {/* <div className="landing-footer">
  About Magic Health → {" "}
  <a
    href="https://magichealth.io/"
    target="_blank"
    rel="noopener noreferrer"
    style={{ 
      color: "inherit", 
      fontWeight: "bold", 
      textDecoration: "none", // Removes the default blue underline
      outline: "none"         // Removes the blue focus box when clicked
    }}
  >
    magichealth.io
  </a>
</div> */}
        </div>
      </div>
    </>
  );
};

export default LandingPage;
